export default {
  data() {
    return {
      isVideoDeviceAvailable: true,
      hasCameraPermission: true,
    };
  },
  async created() {
    try {
      const mediaDevices = await navigator.mediaDevices.enumerateDevices();
      if (mediaDevices && mediaDevices.length) {
        const videoDevices = mediaDevices.filter(device => device.kind === 'videoinput');
        this.isVideoDeviceAvailable = videoDevices && videoDevices.length;
        if (navigator.permissions) {
          navigator.permissions.query({ name: 'camera' }).then(response => {
            this.processCameraPermission(response);
          });
        }
      }
    } catch (error) {
      console.error(error);
      this.isVideoDeviceAvailable = false;
    }
  },
  computed: {
    isCameraSupported() {
      return this.isVideoDeviceAvailable && this.hasCameraPermission;
    },
  },
  methods: {
    processCameraPermission(response) {
      const permissionStatus = response.target || response;
      const permissionState = permissionStatus.state;
      if (permissionState === 'granted') {
        this.hasCameraPermission = true;
      } else if (permissionState === 'denied') {
        this.hasCameraPermission = false;
      } else {
        this.hasCameraPermission = false;
        permissionStatus.onchange = this.processCameraPermission.bind(this);
      }
    },
  },
};
